const UserStatus = {
    ACTIVE: "ACTIVE",
    ARCHIVED: "ARCHIVED"
}

export default UserStatus;